import React from 'react';
import { Col, Row, Container } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { LeadFormStyled } from './styled';
export function FormSkeleton() {
    return (React.createElement(Container, null,
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 6 },
                React.createElement(LeadFormStyled, null,
                    React.createElement(FlexWrapper, { isFullWidth: true, padding: "16x", paddingDesktop: "48px", paddingTablet: "24px", paddingMobile: "16px" },
                        React.createElement(Skeleton, { skeletonProps: {
                                height: 960,
                            } })))))));
}
